import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import { Button } from "components/bootstrap";
import List from "./List";
import FieldGroup from "./FieldGroup";
const Container = styled.div`
  white-space: break-spaces;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr;

  > *:nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  }

  > *:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }
`;
const FilterForm = styled.form`
  display: flex;
`;
const FilterInputWrapper = styled.div`
  margin-right: 5px;
`;
const FilterInput = styled.input`
  width: 100%;
`;
const FieldGroups = styled.div`
  margin-top: 5px;
  margin-bottom: 0;
`;
const FieldsOverview = ({ allFields, activeQueryFields }) => {
  const [currentGroup, setCurrentGroup] = useState("current");
  const [filter, setFilter] = useState(void 0);
  const handleSearch = (e) => setFilter(e.target.value);
  const handleSearchReset = () => setFilter(void 0);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FilterForm, { onSubmit: (e) => e.preventDefault() }, /* @__PURE__ */ React.createElement(FilterInputWrapper, { className: "form-group has-feedback" }, /* @__PURE__ */ React.createElement(
    FilterInput,
    {
      id: "common-search-form-query-input",
      className: "query form-control",
      onChange: handleSearch,
      value: filter || "",
      placeholder: "Filter fields",
      type: "text",
      autoComplete: "off",
      spellCheck: "false"
    }
  )), /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", className: "reset-button", onClick: handleSearchReset }, "Reset"))), /* @__PURE__ */ React.createElement(FieldGroups, null, "List fields of", " ", /* @__PURE__ */ React.createElement(
    FieldGroup,
    {
      selected: currentGroup === "current",
      group: "current",
      text: "current query",
      title: "This shows fields which occur in your current query.",
      onSelect: setCurrentGroup
    }
  ), ", ", /* @__PURE__ */ React.createElement(
    FieldGroup,
    {
      selected: currentGroup === "all",
      group: "all",
      text: "all",
      title: "This shows all fields, but no reserved (gl2_*) fields.",
      onSelect: setCurrentGroup
    }
  ), " or ", /* @__PURE__ */ React.createElement(
    FieldGroup,
    {
      onSelect: setCurrentGroup,
      selected: currentGroup === "allreserved",
      group: "allreserved",
      text: "all including reserved",
      title: "This shows all fields, including reserved (gl2_*) fields."
    }
  ), " fields."), /* @__PURE__ */ React.createElement("hr", null)), /* @__PURE__ */ React.createElement(List, { filter, activeQueryFields, allFields, currentGroup }));
};
const FieldsOverviewWithContext = (props) => /* @__PURE__ */ React.createElement(FieldTypesContext.Consumer, null, (fieldTypes) => {
  const allFields = fieldTypes == null ? void 0 : fieldTypes.all;
  const activeQueryFields = fieldTypes == null ? void 0 : fieldTypes.currentQuery;
  return /* @__PURE__ */ React.createElement(FieldsOverview, { ...props, allFields, activeQueryFields });
});
export default FieldsOverviewWithContext;
